import DatoLink from '@/components/DatoLink/DatoLink'
import { CardCarouselFragment } from './CardCarousel.generated'
import { cn } from '@desoutter/uikit'
import { Image as DatoImage } from 'react-datocms'

type CardCarouselProps = {
	fragment: CardCarouselFragment
}

export default function CardCarousel({ fragment }: CardCarouselProps) {
	const cardClassName = cn(
		'flex flex-col justify-between w-[300px] shrink-0 border-l last:border-r dark:border-gray-800 border-gray-100 p-6 bg-background text-foreground 2xl:z-[60]',
		fragment.link === null && 'cursor-default',
		'hover:border-l-primary duration-200 [&:hover+a]:border-l-primary [&:hover+span]:border-l-primary hover:last:border-r-primary hover:bg-gray-50/25 dark:hover:bg-gray-800',
	)

	const cardContent = (
		<>
			<div className="flex flex-col gap-6 pb-6">
				{fragment.topImage && (
					<DatoImage
						data={fragment.topImage.responsiveImage}
						className={cn(
							'rounded-2xl',
							(fragment.title || fragment.subtitle) &&
								'brightness-75 dark:brightness-75',
						)}
					/>
				)}
				{fragment.title && (
					<h3 className="h3 m-0 break-words">{fragment.title}</h3>
				)}
				{fragment.subtitle && (
					<span className="text-md text-primary">{fragment.subtitle}</span>
				)}
				{fragment.description && (
					<p className="min-h-[120px]">{fragment.description}</p>
				)}
			</div>
			<div>
				{fragment.image && (
					<DatoImage
						data={fragment.image.responsiveImage}
						className="rounded-2xl"
					/>
				)}
			</div>
		</>
	)

	if (fragment.link && fragment.link.__typename) {
		return (
			<DatoLink className={cardClassName} fragment={fragment.link}>
				{cardContent}
			</DatoLink>
		)
	}

	return <div className={cardClassName}>{cardContent}</div>
}
